<form [formGroup]="form" class="p-fluid" novalidate>
  <div class="p-field">
    <label>Name</label>
    <div class="text-900">{{ user?.firstName }} {{ user?.lastName }}</div>
    <small class="text-500">{{ user?.email }}</small>
  </div>

  <div class="p-field mt-3">
    <label for="profile-job">Job title</label>
    <input id="profile-job" type="text" pInputText formControlName="jobTitle"
      placeholder="e.g. Funeral Director and Celebrant" />
  </div>

  <div class="p-field mt-3">
    <label for="profile-bio">Biography <span class="text-500">(Markdown)</span></label>
    <app-markdown-editor formControlName="bio" [heightRem]="9"
      placeholder="How this person introduces themselves to a family."></app-markdown-editor>
  </div>

  <div class="p-field mt-3">
    <label class="toggle-row flex align-items-center gap-2">
      <p-inputSwitch formControlName="isPublicProfile"></p-inputSwitch>
      <span>Published on picaluna.com</span>
    </label>
    <small class="text-500 block mt-1">
      The master switch. Off means this profile is not on the site at all.
    </small>
  </div>

  <div class="p-field mt-3">
    <label>Shown on</label>
    <p-multiSelect [options]="placementOptions" formControlName="placements"
      optionLabel="label" optionValue="value" appendTo="body"
      placeholder="Choose the pages" styleClass="w-full"></p-multiSelect>
    <small class="text-500 block mt-1">
      Which pages this profile appears on. The funeral director directory and the
      About / Team page are separate lists — someone can be on either, both, or neither.
    </small>
    <!-- Warn, never block: published-with-no-placement is a legal state, it
         just renders nowhere. Silently publishing to no page is the confusing
         outcome this call-out exists to prevent. -->
    <small *ngIf="strandedWarning" class="block mt-2 text-orange-600">
      <i class="pi pi-exclamation-triangle" style="font-size: .75rem"></i>
      Published, but no pages chosen — this profile will not appear anywhere.
    </small>
    <!-- The commoner case after the backfill: pages chosen, switch still off. -->
    <small *ngIf="unpublishedWarning" class="block mt-2 text-orange-600">
      <i class="pi pi-exclamation-triangle" style="font-size: .75rem"></i>
      Pages are chosen, but <strong>Published</strong> is off — this profile is not on
      the site. Turn it on above to publish.
    </small>
  </div>

  <div class="p-field mt-3">
    <label for="profile-region">Regions they work in <span class="text-500">(up to {{ maxServedAreas }})</span></label>
    <p-dropdown id="profile-region" [options]="regionOptions" [(ngModel)]="regionPick"
      [ngModelOptions]="{ standalone: true }" [disabled]="servedAreas.length >= maxServedAreas"
      placeholder="Add a region…" [filter]="true" appendTo="body" styleClass="w-full"
      (onChange)="onAddRegion($event.value)"></p-dropdown>
    <div class="flex gap-2 flex-wrap mt-2" *ngIf="servedAreas.length > 0">
      <p-chip *ngFor="let area of servedAreas; let i = index" [label]="area.label"
        [removable]="true" (onRemove)="removeServedArea(i)" icon="pi pi-map-marker"></p-chip>
    </div>
    <small class="text-500 block mt-1">
      The same regions as Website → Regions, so a pick here joins exactly to the
      location pages. Shown on the funeral director directory, not the team page.
    </small>
  </div>

  <!-- Social links. Six separate fields rather than a repeater: the set is
       fixed by what picaluna-v3 renders, and each needs its own icon there. -->
  <div class="p-field mt-4">
    <label>Links</label>
    <div class="formgrid grid">
      <div class="field col-12 md:col-6">
        <small class="text-500 block mb-1">Website</small>
        <input type="text" pInputText class="w-full" formControlName="website" placeholder="https://" />
      </div>
      <div class="field col-12 md:col-6">
        <small class="text-500 block mb-1">LinkedIn</small>
        <input type="text" pInputText class="w-full" formControlName="linkedin" placeholder="https://linkedin.com/in/…" />
      </div>
      <div class="field col-12 md:col-6">
        <small class="text-500 block mb-1">Facebook</small>
        <input type="text" pInputText class="w-full" formControlName="facebook" placeholder="https://facebook.com/…" />
      </div>
      <div class="field col-12 md:col-6">
        <small class="text-500 block mb-1">Instagram</small>
        <input type="text" pInputText class="w-full" formControlName="instagram" placeholder="https://instagram.com/…" />
      </div>
      <div class="field col-12 md:col-6">
        <small class="text-500 block mb-1">TikTok</small>
        <input type="text" pInputText class="w-full" formControlName="tiktok" placeholder="https://tiktok.com/@…" />
      </div>
      <div class="field col-12 md:col-6">
        <small class="text-500 block mb-1">YouTube</small>
        <input type="text" pInputText class="w-full" formControlName="youtube" placeholder="https://youtube.com/@…" />
      </div>
    </div>
  </div>

  <div class="editor-footer mt-4">
    <button pButton pRipple type="button" label="Cancel" class="p-button-text"
      [disabled]="saving" (click)="onCancel()"></button>
    <button pButton pRipple type="button" label="Save profile" icon="pi pi-check"
      [loading]="saving" (click)="onSave()"></button>
  </div>
</form>
